import schema from "../../../gen/schema/witbooking.backoffice.accommodation.v1/Accommodation.json";

export const customSchema = {
  ...schema,
  properties: {
    ...schema.properties,
    multimedia: {
      ...schema.properties.multimedia,
      items: {
        ...schema.properties.multimedia.items,
        properties: {
          ...schema.properties.multimedia.items.properties,
          translations: {
            ...schema.properties.multimedia.items.properties.translations,
            items: {
              ...schema.properties.multimedia.items.properties.translations.items,
              required: ["title"],
            },
            type: "object",
          },
        },
        additionalProperties: true,
      },
    },
    accommodationBaseAdults: {
      ...schema.properties.accommodationBaseAdults,
    },
    customOccupancy: {
      ...schema.properties.occupancy,
      properties: {
        ...schema.properties.occupancy.properties,
        occupancyCombinations: {
          items: {
            type: "string",
          },
          type: "array",
        },
      },
    },
  },
};

const categoryLimitBlockSchema = {
  type: "object",
  properties: {
    enabled: { type: "boolean" },
    included: { type: "integer" },
    max: { type: "integer" },
    tickedExtraTickers: { type: "array", items: { type: "string" } },
  },
};

/**
 * The page while the *Limits per category* section is not visible (flag off, or no extra with a
 * category): today's form.
 */
export const schemaWithoutCategoryLimits = customSchema;

/**
 * The page with the synthetic `categoryLimits` property, keyed by category so that rjsf error
 * paths are `categoryLimits.<CATEGORY>.<field>`. It holds only the blocks of the section: a block
 * with no data would get an empty default object, and rjsf would report that as a change on load.
 */
export function schemaWithCategoryLimits(categories: readonly string[]) {
  return {
    ...customSchema,
    properties: {
      ...customSchema.properties,
      categoryLimits: {
        type: "object",
        properties: Object.fromEntries(
          categories.map(category => [category, categoryLimitBlockSchema])
        ),
      },
    },
  };
}
